import { OrgStructurePage as OrgStructureComponent } from '@components/OrgStructure';
import PlanGate from '@components/common/PlanGate';
import UpgradeBanner from '@components/common/UpgradeBanner';

export const OrgStructurePage = () => {
  return (
    <PlanGate feature="org_units" fallback={<UpgradeBanner feature="org_units" />}>
      <OrgStructureComponent />
    </PlanGate>
  );
};
